<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 v-if="service.id">
          {{ $t('editModel', { model: $tc('models.service', 1) }) }}
        </h1>
        <h1 v-else>
          {{ $t('createModel', { model: $tc('models.service', 1) }) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="service.name"
                                  name="name"
                                  :label="$t('attrs.name')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('name')"
                                  data-vv-name="name"
                                  :data-vv-as="$t('attrs.name')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-if="isGenericCarrier">
                    <v-text-field v-model="service.code"
                                  name="code"
                                  :label="$t('attrs.code')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('code')"
                                  data-vv-name="code"
                                  :data-vv-as="$t('attrs.code')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4 v-else>
                    <v-select v-model="service.code"
                              :items="carrierServiceTypes"
                              item-value="id"
                              item-text="name"
                              :label="$t('attrs.code')"
                              v-validate="'required'"
                              :error-messages="errors.collect('code')"
                              data-vv-name="code"
                              :data-vv-as="$t('attrs.code')"
                              required
                              :disabled="!$auth.isDev() && carrier.freeze_settings"
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="service.status"
                              :items="statuses"
                              item-value="id"
                              item-text="name"
                              :label="$t('attrs.status')"
                              v-validate="'required'"
                              :error-messages="errors.collect('status')"
                              data-vv-name="status"
                              :data-vv-as="$t('attrs.status')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.days"
                                  name="days"
                                  :label="$t('attrs.days')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('days')"
                                  data-vv-name="days"
                                  :data-vv-as="$t('attrs.days')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.extra_kg_price"
                                  name="extra_kg_price"
                                  :label="$t('attrs.extra_kg_price')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('extra_kg_price')"
                                  data-vv-name="extra_kg_price"
                                  :data-vv-as="$t('attrs.extra_kg_price')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.extra_kg_overweight_price"
                                  name="extra_kg_overweight_price"
                                  :label="$t('attrs.extra_kg_overweight_price')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('extra_kg_overweight_price')"
                                  data-vv-name="extra_kg_overweight_price"
                                  :data-vv-as="$t('attrs.extra_kg_overweight_price')"
                                  required
                                  ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.oversize_kg_price"
                                  name="oversize_kg_price"
                                  :label="$t('attrs.oversize_kg_price')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('oversize_kg_price')"
                                  data-vv-name="oversize_kg_price"
                                  :data-vv-as="$t('attrs.oversize_kg_price')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.zone"
                                  name="zone"
                                  :label="$t('attrs.zone')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.extended_zone_price"
                                  name="extended_zone_price"
                                  :label="$t('attrs.extended_zone_price')"
                                  :persistent-hint="true"
                                  :hint="$t('extendedZonePriceHint')"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <TimeDialog
                      :label="$t('attrs.start_at')"
                      :defaultTime="service.start_at"
                      @onSelectTime="val => service.start_at = val"
                      :hint="$t('requiredForTimeValidator')"
                      ></TimeDialog>
                  </v-flex>
                  <v-flex xs12 sm12 md3>
                    <TimeDialog
                      :label="$t('attrs.end_at')"
                      :defaultTime="service.end_at"
                      @onSelectTime="val => service.end_at = val"
                      :hint="$t('requiredForTimeValidator')"
                      ></TimeDialog>
                  </v-flex>

                  <!-- <template v-if="service.service_type === 'international'"> -->
                  <v-flex xs12 sm12 md3>
                    <v-select v-model="service.exchange_rate"
                      :items="exchangeRates"
                      item-value="value"
                      item-text="label"
                      :label="$t('attrs.exchange_rate')"
                      data-vv-name="exchange_rate"
                      :data-vv-as="$t('attrs.exchange_rate')"
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-text-field v-model="service.girth_amount"
                      name="girth_amount"
                      :label="$t('attrs.girth_amount')"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md3 v-if="isEstafeta">
                    <v-checkbox v-model="service.use_of_kg"
                      :label="$t('attrs.use_of_kg')"
                      color="primary"
                      class="shrink mr-4"
                    ></v-checkbox>
                  </v-flex>

                  <!-- Dev -->
                  <v-flex xs12 sm12 md12 v-if="$auth.isDev()">
                    Dev Amounts
                    <v-layout>
                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.international_amount_dev"
                          name="international_amount"
                          :label="`${ $t('attrs.amount') } base`"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.international_percent"
                          name="international_percent"
                          :label="$t('percentage')"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Dev -->

                  <!-- Main Admin -->
                  <v-flex xs12 sm12 md12 v-if="$auth.isDev() || $auth.isMainAdmin()">
                    Main Admin
                    <v-layout>
                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.main_admin_amount"
                          name="international_amount"
                          :label="`${ $t('attrs.amount') } base`"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.main_admin_percent"
                          name="international_percent"
                          :label="$t('percentage')"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Main Admin -->

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.international_amount"
                          name="international_amount"
                          :label="$t('attrs.amount')"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md3>
                        <v-text-field v-model="service.client_percentge"
                          name="client_percentge"
                          :label="$t('attrs.client_percentage')"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <!-- </template> -->

                  <v-flex xs12 sm12 md12>
                    <v-layout>
                      <v-checkbox v-model="service.trackable"
                                  :label="$t('attrs.trackable')"
                                  color="primary"
                                  class="shrink mr-4"
                                  ></v-checkbox>

                      <v-checkbox v-model="service.has_pickup"
                                  label="Pickup"
                                  color="primary"
                                  class="shrink mr-2"
                                  ></v-checkbox>

                      <v-checkbox v-if="service.service_type == 'national'" v-model="service.use_quoted_rates"
                                  :label="$t('useQuotedRates')"
                                  color="primary"
                                  class="shrink mr-2"
                                  ></v-checkbox>

                      <v-checkbox v-if="service.service_type == 'national' && service.use_quoted_rates" v-model="service.use_static_rates"
                                  :label="$t('useStaticRates')"
                                  color="primary"
                                  class="shrink mr-2"
                                  ></v-checkbox>

                      <v-checkbox v-if="$auth.isDev()" v-model="service.edit_admin_cost"
                                  :label="$t('editAdminCost')"
                                  color="primary"
                                  class="shrink mr-2"
                                  ></v-checkbox>
                    </v-layout>
                  </v-flex>

                  <!-- <v&#45;flex xs12 sm12 md3> -->
                  <!--   <v&#45;checkbox v&#45;model="service.extended_zone" -->
                  <!--               :label="$t('applyExtendedZone?')" -->
                  <!--               color="primary" -->
                  <!--               ></v&#45;checkbox> -->
                  <!-- </v&#45;flex> -->


                  <v-flex xs12 sm12 md12>
                    <v-radio-group
                      :label="`${$t('attrs.serviceType')}:`"
                      v-model="service.service_type"
                      v-validate="'required'"
                      :error-messages="errors.collect('service type')"
                      data-vv-name="service type"
                      :data-vv-as="$t('attrs.serviceType')"
                      row
                      required>
                      <v-radio :label="$t('list.serviceTypes.national')" value="national"></v-radio>
                      <v-radio :label="$t('list.serviceTypes.zonal')" value="zonal"></v-radio>
                      <v-radio :label="$t('list.serviceTypes.international')" value="international"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs7 sm7 md7>


                    <v-checkbox v-for="validator in filteredValidators" :key="validator.id"
                                class="ma-0"
                                v-model="validatorIds"
                                :label="validator.name"
                                :hint="validator.description"
                                :hide-details="!validator.description"
                                persistent-hint
                                :value="validator.id"
                                color="primary"
                                ></v-checkbox>
                  </v-flex>

                  <v-flex xs5 sm5 md5>
                    <v-checkbox v-for="(day, i) in days" :key="day"
                                class="ma-0"
                                v-model="service.week_days"
                                :label="$t(day)"
                                :value="i"
                                color="primary"
                                ></v-checkbox>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Enum from '@/client/enum'
import Validator from '@/client/validator'
import Carrier from '@/client/carrier'
import Service from '@/client/service'

export default {
  name: 'ServiceFormView',

  props: {},

  data () {
    return {
      loading: false,
      validators: [],
      enums: [],
      validatorIds: [],
      carrier: {},
      service: {},
      statuses: [
        { id: 'active', name: this.$t('list.statuses.active') },
        { id: 'suspended', name: this.$t('list.statuses.suspended') }
      ],
      days: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
      ]
    }
  },

  components: {
  },

  computed: {
    filteredValidators() {
      return this.validators.filter(validator => {
        return !(
          (
            validator.name == 'PostalCodeValidator' ||
              validator.name == 'ExcludedPostalCodeValidator'
          ) &&
            this.service.service_type == 'zonal'
        )
      })
    },

    providerCode () {
      if (!this.carrier) { return '' }
      if (!this.carrier.provider) { return '' }

      return this.carrier.provider.code
    },

    isGenericCarrier () {
      return this.providerCode === 'GenericCarrier'
    },

    carrierServiceTypes () {
      if (!this.providerCode) { return [] }

      return this.enums.service_types[this.providerCode] || []
    },

    exchangeRates () {
      const exch_rates = [
        {
          value: 1,
          label: 1
        },
        {
          value: 2,
          label: 2
        },
        {
          value: 3,
          label: 3
        }
      ]
      return exch_rates
    },

    isEstafeta () {
      return this.providerCode === 'Estafeta'
    },
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      this.rejectValidators()
      this.resetInternatioalService()
      this.loading = true
      try {
        this.service.carrier_id = this.carrier.id
        this.service.validator_ids = this.validatorIds
        await this.service.save()
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    rejectValidators () {
      if (this.service.service_type === 'zonal') {
        for (let i=0; i < this.validators.length; i++) {
          if(this.validators[i].name === 'PostalCodeValidator' || this.validators[i].name === 'ExcludedPostalCodeValidator') {
              this.validatorIds = this.validatorIds.filter( id => id !== this.validators[i].id )
          }
        }
      }
    },

    resetInternatioalService () {
      if (this.service.service_type !== 'international' && !this.$route.params.id) {
        this.service.international_amount = ''
        this.service.international_percent = ''
        this.service.client_percentge = ''
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.validators = await Validator.all()
    this.enums = await Enum.all()
    this.carrier = await Carrier.findOne(this.$route.params.carrierId, { include: 'provider' })


    this.service = new Service({ status: 'active', service_type: 'national', week_days: [0, 1, 2, 3, 4, 5, 6] })

    const id = this.$route.params.id
    if (id) {
      this.service = await Service.findOne(id, { include: 'validators' })
      this.validatorIds = this.service.validators.map(o => o.id)
    } else {
      if(!this.$auth.isDev() && this.carrier.freeze_settings) this.back()
    }

  }
}
</script>
